var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSeller = function SvgSeller(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 25,
    viewBox: "0 0 34 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7907 9.34393C19.0948 9.34393 20.9627 7.47607 20.9627 5.17196C20.9627 2.86785 19.0948 1 16.7907 1C14.4866 1 12.6188 2.86785 12.6188 5.17196C12.6188 7.47607 14.4866 9.34393 16.7907 9.34393Z",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3177 24.5514V17.1495C11.3177 14.1439 13.785 11.6766 16.7906 11.6766C19.7963 11.6766 22.2635 14.1439 22.2635 17.1495V24.5514",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7682 14.0542C30.3539 14.0542 31.6393 12.7688 31.6393 11.1832C31.6393 9.59754 30.3539 8.31213 28.7682 8.31213C27.1826 8.31213 25.8972 9.59754 25.8972 11.1832C25.8972 12.7688 27.1826 14.0542 28.7682 14.0542Z",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24.5514V19.4374C25 17.3739 26.7047 15.6692 28.7682 15.6692C30.8318 15.6692 32.5364 17.3739 32.5364 19.4374V24.5514",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76824 14.0542C6.35387 14.0542 7.63927 12.7688 7.63927 11.1832C7.63927 9.59754 6.35387 8.31213 4.76824 8.31213C3.18262 8.31213 1.89722 9.59754 1.89722 11.1832C1.89722 12.7688 3.18262 14.0542 4.76824 14.0542Z",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 24.5514V19.4374C1 17.3739 2.70467 15.6692 4.76822 15.6692C6.83178 15.6692 8.53645 17.3739 8.53645 19.4374V24.5514",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSeller, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/seller.1f466b36.svg";
export { ForwardRef as ReactComponent };